var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1408_2997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 28H21C19.7089 28 18.6667 26.9423 18.6667 25.6435V18.574C18.6667 17.2752 17.6244 16.2175 16.3333 16.2175H11.6667C10.3756 16.2175 9.33333 17.2752 9.33333 18.574V25.6435C9.33333 26.9423 8.29111 28 7 28H2.33333C1.04222 28 0 26.9423 0 25.6435V8.24582C0 7.35143 0.497778 6.53482 1.29111 6.13819L12.9578 0.250816C13.6111 -0.0836053 14.3889 -0.0836053 15.0422 0.250816L26.7089 6.13819C27.5022 6.53482 28 7.35143 28 8.24582V25.6435C28 26.9423 26.9578 28 25.6667 28Z",
    fill: "#00C8D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1408_2997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.aa1956b679ea3756027d8e769318cac5.svg";
export { ForwardRef as ReactComponent };